import React, {Component} from "react";
import {withRouter} from 'react-router-dom';
import TrackingToolsToolBar from '../TrackingToolsToolBar/TrackingToolsToolBar';
import queryString from "query-string";

class ManageTrackShipment extends Component {

  getActiveTool = () => {
    const querystringParams = queryString.parse(this.props.location.search);
    const validTrackingIds = querystringParams.validIds;
    const invalidTrackingIds = querystringParams.invalidIds;
    const advanced = querystringParams.advanced;

    if (advanced) {
      return "advancedSearch";
    }

    if(validTrackingIds !== undefined)
    {
      if (validTrackingIds.length > 0)
        return 'trackByAirWaybill';
    }
    if(invalidTrackingIds !== undefined)
    {
      if (invalidTrackingIds.length > 0)
        return 'trackByAirWaybill';
    }
    return 'trackByAirWaybill';

  };

  render() {
    return(
      <div>
        <div className="track-shipment-header">
          Tracking
        </div>
        <div className="track-shipment-text">
          Search for your shipment below by entering your air waybill number or your account number, and get up to date information with our tracking tool.
        </div>
        <TrackingToolsToolBar
          activeTool={this.getActiveTool()}
          showToolsLabel={false}
          showTrackShipmet={false}
          showFlightScheduleSearch={false}
          showTrackAirWayBill={true}
          showAdvancedSearch={true}
          addEmailNotiSignUp = {true}
        />

  </div>
    )
  }

}

export default withRouter(ManageTrackShipment);



// WEBPACK FOOTER //
// ./src/components/ManageTrackShipment/ManageTrackShipment.js